import classNames from "classnames";
import { FC, LabelHTMLAttributes, ReactNode } from "react";

interface InputLabelType extends LabelHTMLAttributes<HTMLLabelElement> {
  children: ReactNode;
  className?: string;
}

const InputLabel: FC<InputLabelType> = ({ children, className, ...props }) => {
  return (
    <label
      className={classNames(
        "input-label text-sm font-medium text-font/90 leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70 cursor-pointer",
        className
      )}
      {...props}
    >
      {children}
    </label>
  );
};

export default InputLabel;
